import { Injectable } from '@angular/core';
import {ServerService} from "./ServerService";
import {HttpClient} from "@angular/common/http";


@Injectable({
  providedIn: 'root'
})
export class ModulosService extends ServerService {

  constructor(public   http: HttpClient) {
    super(http);
  }

  listeModulos(query: any = {}) {
    return this.obtenha('/modulos', query)
  }

  selecioneModulo(id: number) {
    return this.obtenha(`/modulos/${id}`, {});
  }

  insiraModulo(dados: any) {
    return this.facaPost('/modulos', dados);
  }

  atualizeModulo(modulo: any) {
    return this.facaPut(`/modulos/${modulo.id}`, modulo);
  }

  removaModulo(modulo: any) {
    return this.remova(`/modulos/${modulo.id}`, {});
  }

  // Método para ativar módulos (compatível com o sistema anterior)
  ativeModulosGratuitos(empresaId: any, modulos: any) {
    // Se empresaId é um objeto (empresa), usar o id
    const idEmpresa = typeof empresaId === 'object' ? empresaId.id : empresaId;

    return this.facaPost(`/modulos/${idEmpresa}/gratuitos/ativar`, { modulos: modulos });
  }

  desativarModuloNaEmpresa(empresaId: number, moduloId: number) {
    return this.facaPost(`/modulos/${empresaId}/desativar/${moduloId}`, {});
  }

  gerarFaturaAtivacaoModulos(empresaId: any, dadosFatura: any) {
    return this.facaPost(`/modulos/${empresaId}/fatura-ativacao`, dadosFatura);
  }

  sincronizeFaturaAtivacao(fatura: any) {
    return this.obtenha(`/modulos/faturas/${fatura.id}/status`, {});
  }

  // Novo método para buscar valores calculados dos módulos
  obtenhaModulosComValoresCalculados(empresaId: number) {
    return this.obtenha(`/modulos/empresa/${empresaId}/valores`, {});
  }

  obtenhaCentralRecursos(empresaId: number) {
    return this.obtenha(`/modulos/empresa/${empresaId}/central-recursos`, {});
  }

  obtenhaCentralContratacao(empresaId: number) {
    return this.obtenha(`/modulos/empresa/${empresaId}/central-contratacao`, {});
  }

  obtenhaDisponibilidadeCentralContratacao(empresaId: number) {
    return this.obtenha(`/modulos/empresa/${empresaId}/central-contratacao/disponibilidade`, {});
  }

  ativeCentralContratacaoSemCobranca(empresaId: number, itens: any[]) {
    return this.facaPost(
      `/modulos/empresa/${empresaId}/central-contratacao/ativar-sem-cobranca`,
      {itens}
    );
  }

  removaRecursoCentralContratacao(empresaId: number, item: any) {
    return this.facaPost(
      `/modulos/empresa/${empresaId}/central-contratacao/remover-recurso`,
      {item}
    );
  }

  ativeControleCustoEstoque(empresaId: number) {
    return this.facaPost(
      `/modulos/empresa/${empresaId}/central-contratacao/estoque/custos/ativar`,
      {}
    );
  }

  simuleCentralContratacao(empresaId: number, itens: any[]) {
    return this.facaPost(`/modulos/empresa/${empresaId}/central-contratacao/simular`, {itens});
  }

  gereFaturaCentralContratacao(empresaId: number, dados: any) {
    return this.facaPost(`/modulos/empresa/${empresaId}/central-contratacao/fatura-ativacao`, dados);
  }

  sincronizeFaturaCentralContratacao(empresaId: number, fatura: any) {
    return this.facaPost(`/modulos/empresa/${empresaId}/central-contratacao/faturas/${fatura.id}/sincronizar`, {});
  }

  canceleFaturaCentralContratacao(empresaId: number, fatura: any) {
    return this.facaPost(`/modulos/empresa/${empresaId}/central-contratacao/faturas/${fatura.id}/cancelar`, {});
  }

  atualizeConfigModulo(empresaId: number, dados: any){
    return this.facaPost(`/modulos/${empresaId}/config`, dados);
  }
}
